var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalStrikers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9C6.15469 9 7.5 7.65469 7.5 6C7.5 4.34531 6.15469 3 4.5 3C2.84531 3 1.5 4.34531 1.5 6C1.5 7.65469 2.84531 9 4.5 9ZM25.5 9C27.1547 9 28.5 7.65469 28.5 6C28.5 4.34531 27.1547 3 25.5 3C23.8453 3 22.5 4.34531 22.5 6C22.5 7.65469 23.8453 9 25.5 9ZM27 10.5H24C23.175 10.5 22.4297 10.8328 21.8859 11.3719C23.775 12.4078 25.1156 14.2781 25.4062 16.5H28.5C29.3297 16.5 30 15.8297 30 15V13.5C30 11.8453 28.6547 10.5 27 10.5ZM15 10.5C17.9016 10.5 20.25 8.15156 20.25 5.25C20.25 2.34844 17.9016 0 15 0C12.0984 0 9.75 2.34844 9.75 5.25C9.75 8.15156 12.0984 10.5 15 10.5ZM18.6 12H18.2109C17.2359 12.4688 16.1531 12.75 15 12.75C13.8469 12.75 12.7688 12.4688 11.7891 12H11.4C8.41875 12 6 14.4188 6 17.4V18.75C6 19.9922 7.00781 21 8.25 21H21.75C22.9922 21 24 19.9922 24 18.75V17.4C24 14.4188 21.5812 12 18.6 12ZM8.11406 11.3719C7.57031 10.8328 6.825 10.5 6 10.5H3C1.34531 10.5 0 11.8453 0 13.5V15C0 15.8297 0.670312 16.5 1.5 16.5H4.58906C4.88438 14.2781 6.225 12.4078 8.11406 11.3719Z",
    fill: "#33B647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalStrikers);
export default __webpack_public_path__ + "static/media/totalStrikers.3023498d11ce3c009ab8dfc313931029.svg";
export { ForwardRef as ReactComponent };